import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface BulkShiftUploadSuccessProps extends BaseTemplateProps {
  csvHistoryLink: string
}

export const BulkShiftUploadSuccess: TemplateDefinition<BulkShiftUploadSuccessProps> = {
  renderParams: (props: BulkShiftUploadSuccessProps) => ({
    messageKey: 'notificationsDomain.templates.bulkShiftUploadCompleteSubheader',
    values: {
      givenName: props.givenName,
      csvHistoryLink: props.csvHistoryLink,
    },
  }),
  getLink: (props: BulkShiftUploadSuccessProps): string => props?.csvHistoryLink || '',
}
